import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormattingService {

  constructor() { }

  formatCurrency(value: number) {
    if (value != null) {
      let strVal = String(value);
      let commaRemoved = strVal.replace(',', '');
      let numbVal = Number(commaRemoved);
      let formattedStr = numbVal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return formattedStr;
    }
    else {
      return "0.00";
    }
  }
  removeFormattedCurrency(value: string) {
    let commaRemoved = value.replace(',', '');
    let num = Number(commaRemoved);
    return num;
  }
}
